import React from 'react';
import NoDataRow from '../../../common/NoDataRow';
import PropTypes from 'prop-types';
import TableSkeleton from '../../../common/skeletons/TableSkeleton';
import Button from '../../../common/formInputs/Button';
import Avatar from '../../../common/Avatar';
import { shortformatDate } from '../../../../utils';

const TicketListTable = ({ loading, logged_in_employee_role, ticketListData, goToViewTicket, message, goToEditTicket, openDeleteModal }) => {
    return (
        <div className="card-body">
            {loading ? (
                <div className="card-body">
                    <div className="dimmer active">
                        <TableSkeleton columns={8} rows={ticketListData.length} />
                    </div>
                </div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-hover table-vcenter mb-0 table_custom spacing8 text-nowrap">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Title</th>
                                {logged_in_employee_role !== 'employee' &&
                                    <th>Assigned To</th>
                                }
                                <th>Assigned At</th>
                                <th>Progress</th>
                                <th>Duration</th>                            
                                {logged_in_employee_role !== 'employee' &&
                                    <th>Action</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {ticketListData.length > 0 ? (
                                ticketListData.map((ticket, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <div className="font-15"></div>
                                            <h6
                                                className="mb-0 text-truncate"
                                                onClick={() => goToViewTicket(ticket, ticket.ticket_id)}
                                                style={{ cursor: 'pointer', color: '#007bff' }}
                                            >
                                                {ticket.title}</h6>
                                            <span title={ticket.description.replace(/<[^>]+>/g, '')}>
                                                {ticket.description.replace(/<[^>]+>/g, '').length < 10
                                                    ? ticket.description.replace(/<[^>]+>/g, '')
                                                    : `${ticket.description.replace(/<[^>]+>/g, '').substring(0, 10)} ...`}
                                            </span>

                                           <div className="text-muted d-flex align-items-center gap-2">
                                            <div className="tag-wrapper">
                                                
                                                <span
                                                    className={`tag mr-1 small ${
                                                        ticket.priority === "high"
                                                            ? "tag-danger"
                                                            : ticket.priority === "medium"
                                                            ? "tag-warning"
                                                            : "tag-success"
                                                    }`}
                                                >
                                                    {ticket.priority.toUpperCase()}
                                                </span>

                                                <div className="tooltip-box">
                                                    Priority: {ticket.priority.toUpperCase()}
                                                </div>
                                            </div>
                                            <div className="tag-wrapper">
                                                
                                                <span
                                                    className={`tag ml-1 small ${
                                                        ticket.status === "to-do"
                                                            ? "tag-success"
                                                            : ticket.status === "in-progress"
                                                            ? "tag-warning"
                                                            : "tag-danger"
                                                    }`}
                                                >
                                                    {ticket.status === "to-do"
                                                        ? "PENDING"
                                                        : ticket.status === "in-progress"
                                                        ? "IN PROGRESS"
                                                        : "COMPLETED"}
                                                </span>

                                                <div className="tooltip-box">
                                                    Status: {ticket.status === "to-do"
                                                        ? "PENDING"
                                                        : ticket.status === "in-progress"
                                                        ? "IN PROGRESS"
                                                        : "COMPLETED"}
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                        {logged_in_employee_role !== 'employee' &&
                                            <td className='d-flex align-items-center mt-3'>
                                                <Avatar
                                                    profile={ticket.assigned_to.profile}
                                                    first_name={ticket.assigned_to.first_name}
                                                    last_name={ticket.assigned_to.last_name}
                                                    size={40}
                                                    className="avatar avatar-blue add-space me-2"
                                                    onError={(e) => e.target.src = '/assets/images/sm/avatar2.jpg'}
                                                />
                                                <div className="ml-3">
                                                    <h6 className="mb-0">
                                                        {`${ticket.assigned_to.first_name} ${ticket.assigned_to.last_name}`}
                                                    </h6>
                                                </div>
                                            </td>
                                        }
                                        <td><div className="text-info">{shortformatDate(ticket.assigned_at)}</div></td>

                                        <td style={{ width: ticket.progress }}>
                                            <div className="clearfix">
                                                <div className="float-left"><strong>{ticket.progress}</strong></div>
                                                <div className="float-right"><small className="text-muted">Progress</small></div>
                                            </div>
                                            <div className="progress progress-xs">
                                                <div className="progress-bar bg-blue" role="progressbar" style={{ width: ticket.progress }} aria-valuemin={0} aria-valuemax={100} data-width={ticket.progress} />
                                            </div>
                                        </td>
                                        <td className='text-center'>
                                            <div className="text-pink" title="Due Date">{ticket.due_date ? shortformatDate(ticket.due_date) : '--/--/--'}</div>
                                            <div className="text-green" title="Completed At">{ticket.completed_at ? shortformatDate(ticket.completed_at) : null}</div>
                                        </td>
                                        <td>
                                            {logged_in_employee_role !== 'employee' &&
                                                <>
                                                    <Button
                                                        icon="fa fa-edit"
                                                        className="btn-icon"
                                                        title="Edit"
                                                        onClick={() => goToEditTicket(ticket, ticket.ticket_id)}
                                                    />

                                                    <Button
                                                        icon="fa fa-trash-o text-danger"
                                                        className="btn-icon btn-sm js-sweetalert"
                                                        title="Delete"
                                                        dataToggle="modal"
                                                        dataTarget="#deleteTicketModal"
                                                        onClick={() => openDeleteModal(ticket.ticket_id)}
                                                        dataType="confirm"
                                                    />
                                                </>
                                            }
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <NoDataRow colSpan={8} message="No tickets to display" />
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
};

TicketListTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    ticketListData: PropTypes.array.isRequired,
    goToViewTicket: PropTypes.func.isRequired,
    message: PropTypes.string,
    goToEditTicket: PropTypes.func.isRequired,
    openDeleteModal: PropTypes.func.isRequired,
    logged_in_employee_role: PropTypes.string.isRequired
};

export default TicketListTable;
